import deLocale from 'element-ui/lib/locale/lang/de' //引入element语言包
const de = {
  Login: {
    ToLogin: 'einloggen',
    PhoneLogin: 'Login mit Telefonnummer',
    EmailLogin: 'E-Mail-Anmeldung',
    PhonePlaceholder: 'Bitte geben Sie Ihre Telefonnummer ein',
    EmailPlaceholder: 'Enter email',
    Code: 'Prüfcode',
    and: 'und',
    BeforeText: 'Die Erstellung eines Kontos stellt Ihre Zustimmung und Compliance dar',
    UserAgreement: 'Nutzungsvereinbarung',
    privacy: 'Datenschutzerklärung',
    errorMessage: 'Fehler im Verifizierungscode',
    readTitle: 'Lesen und stimmen Sie der folgenden Vereinbarung zu',
    readBefore: 'Um die Sicherheit Ihrer persönlichen Daten zu gewährleisten, lesen Sie bitte zuerst und stimmen Sie zu.',
    cancel: 'Abbrechen',
    agree: 'Einverständnis und Fortsetzung',
    error1:'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    error2:'Bitte geben Sie die richtige Telefonnummer ein.',
    error3:'Bitte geben Sie den Verifikationscode ein',
    success:'Erfolgreich angemeldet'
  },
  ...deLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default de;
